const AccuracyType = Object.freeze({
  ROOFTOP: "ROOFTOP",
  CENTER: "CENTER",
  INTERPOLATION_OFFSET: "INTERPOLATION_OFFSET",
  INTERPOLATION: "INTERPOLATION",
  APPROXIMATE: "APPROXIMATE"
});
export default AccuracyType;